import { render, staticRenderFns } from "./AloneTalk.vue?vue&type=template&id=4718e77a&scoped=true"
import script from "./AloneTalk.vue?vue&type=script&lang=js"
export * from "./AloneTalk.vue?vue&type=script&lang=js"
import style0 from "./AloneTalk.vue?vue&type=style&index=0&id=4718e77a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4718e77a",
  null
  
)

export default component.exports